import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCalendar, faUser } from '@fortawesome/free-regular-svg-icons';
import { faAward } from '@fortawesome/free-solid-svg-icons';
import styles from './_index.module.css';

const features = [
  {
    icon: faCalendar,
    title: 'Multiple Locations',
    description: 'Training events held across the country throughout the year.',
  },
  {
    icon: faUser,
    title: 'Expert Instructors',
    description: 'Sessions led by both men and women towing professionals.',
  },
  {
    icon: faAward,
    title: 'Hands-On Training',
    description: 'Real-world towing and backing up stations held on a closed course.',
  },
];

export function WhyChooseSection() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentSection}>
        <h2 className="headline-3-small-semibold">Why Choose Ford Towing Bootcamp</h2>
        <p className={`body-1-regular ${styles.subtitle}`}>
          Our bootcamp provides a unique, hands-on experience for all skill levels in a low-pressure learning
          environment.
        </p>

        <div className={styles.cardGrid}>
          {features.map((feature, index) => (
            <div key={index} className={styles.card}>
              <div className={styles.iconWrapper}>
                <FontAwesomeIcon icon={feature.icon as IconProp} className={styles.icon} />
              </div>
              <h3 className={styles.cardTitle}>{feature.title}</h3>
              <p className={styles.cardDescription}>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
